// Chakra imports
import {
  Flex,
  useColorModeValue,
  Button,
  Grid,
  GridItem,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  TabIndicator
} from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import React, { useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { mkConfig, generateCsv, download } from 'export-to-csv';
//import TablaCobranzas from "views/Grillas/CobranzasGrilla";

//////////nuevos
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import { jsPDF } from 'jspdf';
import jsonToTable from 'json-to-table';

import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es"; // the locale you want
import dayjs from "dayjs";
import GrillaEffect from "views/Grillas/GrillaEffect";
import DataLabel from "views/Cards/DataLabel";
registerLocale("es", es); // register it with the name you want

const theme = createTheme({
  palette: {}
});

function Cobranzas() {
  const url = `${process.env.REACT_APP_API_URL}/querysextgrilla/`;
  const defaultFecha = [
    { id: 'periodo_cobranza', value: dayjs().subtract(1, 'month').format('YYYY-MM') }
  ];
  const [dataPdoEnte, setDataPdoEnte] = useState([]);
  const [dataPdoEnteDia, setDataPdoEnteDia] = useState([]);
  const [dataPdoDia, setDataPdoDia] = useState([]);
  const [filterCobranza, setfilterCobranza] = useState([...defaultFecha]);

  const colsPdoEnte = {
    periodo_cobranza: { caption: 'Pdo. Cobranza', enableColumnFilter: true },
    ente: { caption: 'Ente', enableColumnFilter: true },
    importe: { caption: 'Importe', enableColumnFilter: false },
  };

  const colsPdoEnteDia = {
    periodo_cobranza: { caption: 'Pdo. Cobranza', enableColumnFilter: true },
    dia_cobranza: { caption: 'Dia Cobranza', enableColumnFilter: true },
    ente: { caption: 'Ente', enableColumnFilter: true },
    importe: { caption: 'Importe', enableColumnFilter: false },
  }

  const colsPdoDia = {
    periodo_cobranza: { caption: 'Pdo. Cobranza', enableColumnFilter: true },
    dia_cobranza: { caption: 'Dia Cobranza', enableColumnFilter: true },
    importe: { caption: 'Importe', enableColumnFilter: false },
  }

  ///exporta csv
  const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
  });
  const GenerarCsv = async () => {

    try {
      // Realiza la solicitud a la API       
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/19`;

      const rest = await fetch(baseURL,
        {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "Authorization": localStorage.getItem('token'),
          },
          body: JSON.stringify({
            fdesde: new Date(startDate).toLocaleDateString(),
            fhasta: new Date(endDate).toLocaleDateString()
          })
        });

      const resulte = await rest.json();
      // console.log(" get consulta ", resulte);          
      // Convierte la respuesta a formato JSON
      const csv = generateCsv(csvConfig)(resulte);
      download(csvConfig)(csv);

    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }

  };

  ///exporta pdf 
  const GenerarPdf = async () => {

    try {
      // Realiza la solicitud a la API       
      const baseURL = `${process.env.REACT_APP_API_URL}/querysext/19`;

      const rest = await fetch(baseURL,
        {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            "Authorization": localStorage.getItem('token'),
          },
          body: JSON.stringify({
            fdesde: new Date(startDate).toLocaleDateString(),
            fhasta: new Date(endDate).toLocaleDateString()
          })
        });

      const resulte = await rest.json();

      const tabled = jsonToTable(resulte);
      let nombresCampos = tabled[0];
      let datos = tabled.shift();
      const doc = new jsPDF();

      doc.autoTable({
        head: [nombresCampos],
        body: tabled,
        margin: { top: 10 },
        styles: {
          minCellHeight: 4,
          halign: "left",
          valign: "center",
          fontSize: 4,
        },
      });
      doc.save('pdf-cobranzas.pdf');

    } catch (error) {
      console.error(`Error al  generar csv : ${error.message}`);
      throw error;
    }

  };

  //////////////
  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Card overflowX={{ sm: "scroll", xl: "hidden" }} pb="0px">
        <CardBody size='sm'>
          <Grid templateColumns={{ sm: "repeat(3, 1fr)", xl: "repeat(3, 1fr)" }} gap='22px'>
            <GridItem colSpan={2}>
              <Card minH='125px'>
                <CardBody px='2px'>
                  <Grid templateColumns={{ sm: "repeat(3, 1fr)", xl: "repeat(3, 1fr)" }} gap='5px'>
                    <DataLabel url={url + '?id=' + 64} columns={colsPdoEnteDia} filters={filterCobranza} label={"TOTAL COBRADO"} />
                    <DataLabel filters={filterCobranza} isMoney={false} countDateColumn={'periodo_cobranza'} countDayColumn={'dia_cobranza'} label={"CANTIDAD DE DIAS"} />
                  </Grid>
                </CardBody>
              </Card>
            </GridItem>
            <GridItem colSpan={1}>
              <Card minH='125px'>
                <Flex direction='column'>
                  <Flex
                    flexDirection='row'
                    align='center'
                    justify='center'
                    w='100%'
                    mb='25px'>
                    <Flex align='center'>
                      {/* <Button
                        fontSize='13px'
                        fontWeight='bold'
                        w='100%'
                        h='45'
                        variant='solid'
                        //colorScheme='green'
                        onClick={GenerarCsv}
                      >
                        Exportar CSV
                      </Button> */}
                    </Flex>
                    <Flex align='center'>
                      {/* <Button
                        fontSize='13px'
                        fontWeight='bold'
                        w='100%'
                        h='45'
                        variant='solid'
                        //colorScheme='red'
                        onClick={GenerarPdf}
                      >
                        Exportar PDF
                      </Button> */}
                    </Flex>
                  </Flex>
                </Flex>
              </Card>
            </GridItem>
          </Grid>
          <Card p='16px' my='24px'>
            <CardBody >
              <Tabs variant='enclosed'>
                <TabList>
                  <Tab>Por Periodo y Ente</Tab>
                  <Tab>Por Periodo, Ente y Dia</Tab>
                  <Tab>Por Periodo y Dia</Tab>
                </TabList>
                <TabIndicator mt='-1.5px' height='2px' bg='blue.500' borderRadius='1px' />
                <TabPanels>
                  <TabPanel p={0}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                      <ThemeProvider theme={theme}>
                        <GrillaEffect
                          data={dataPdoEnte} updateData={setDataPdoEnte}
                          filters={filterCobranza} updateFilters={setfilterCobranza}
                          idRemoto={62}
                          colsHeaders={colsPdoEnte} 
                          defaultSorting={[
                                  { id: 'periodo_cobranza', desc: true },
                                  { id: 'ente', desc: false }
                                ]}/>
                      </ThemeProvider>
                    </LocalizationProvider>
                  </TabPanel>
                  <TabPanel p={0}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                      <ThemeProvider theme={theme}>
                        <GrillaEffect
                          data={dataPdoEnteDia} updateData={setDataPdoEnteDia}
                          filters={filterCobranza} updateFilters={setfilterCobranza}
                          idRemoto={63}
                          colsHeaders={colsPdoEnteDia} 
                          defaultSorting={[
                                  { id: 'periodo_cobranza', desc: true },
                                  { id: 'dia_cobranza', desc: true },
                                  { id: 'ente', desc: false }
                                ]}/>
                      </ThemeProvider>
                    </LocalizationProvider>
                  </TabPanel>
                  <TabPanel p={0}>
                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="es">
                      <ThemeProvider theme={theme}>
                        <GrillaEffect
                          data={dataPdoDia} updateData={setDataPdoDia}
                          filters={filterCobranza} updateFilters={setfilterCobranza}
                          idRemoto={71}
                          colsHeaders={colsPdoDia} 
                          defaultSorting={[
                                  { id: 'periodo_cobranza', desc: true },
                                  { id: 'dia_cobranza', desc: true },
                                ]}/>
                      </ThemeProvider>
                    </LocalizationProvider>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            </CardBody>
          </Card>
        </CardBody>
      </Card>
    </Flex>

  );
}

export default Cobranzas;
